import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '@core/constants';

@Injectable({
  providedIn: 'root',
})
export class GetsStateService {
  constructor(
    private http: HttpClient,
    @Inject(API_URL) private apiUrl: string
  ) {}

  get(postalCode: string): Observable<string | unknown> {
    return this.http.get<string>(
      `${this.apiUrl}/api/addresses/postalCode/${postalCode}/state`
    );
  }
}
